import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/cn';

const badge = cva(
  'inline-flex items-center gap-1 rounded-wc-pill px-[10px] py-[3px] text-[11px] font-bold uppercase tracking-[0.04em]',
  {
    variants: {
      tone: {
        blue: 'bg-selected text-accent',
        dark: 'bg-wc-dark text-white dark:bg-raised dark:text-primary',
        green: 'bg-tint-success text-tint-success-text',
        yellow: 'bg-tint-warning text-tint-warning-text',
        red: 'bg-tint-error text-tint-error-text',
        gray: 'bg-tint-neutral text-tint-neutral-text',
      },
    },
    defaultVariants: { tone: 'blue' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badge> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badge({ tone }), className)} {...props} />;
}
